import { isExistInEnum } from "@/shared/helpers";
import { useScroll } from "@/shared/hooks";
import { Tab } from "@ab.uitools/ui-library/components/Tab";
import type { TTabItem } from "@ab.uitools/ui-library/components/Tab/types";
import { type Dispatch, type SetStateAction, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface Props<T extends Record<string, string>> {
  tabEnum: T;
  activeTab?: string;
  className?: string;
  getTabItems: (t: any) => TTabItem[];
  selectedTab: string;
  setSelectedTab: Dispatch<SetStateAction<string>>;
}

export const ScrollableTab = <T extends Record<string, string>>({
  activeTab,
  tabEnum,
  className,
  getTabItems,
  selectedTab,
  setSelectedTab,
}: Props<T>) => {
  const { t } = useTranslation();

  const {
    isAtEnd,
    isAtStart,
    scrollContainerRef,
  } = useScroll();

  const onTabChange = (value: string) => {
    setSelectedTab(value);
  };

  useEffect(() => {
    if (
      activeTab &&
      isExistInEnum(tabEnum, activeTab)
    ) {
      setSelectedTab(tabEnum?.[activeTab]);
    }
  }, [activeTab]);

  return (
    <div className="position-relative full-width overflow-hidden">
      <div
        ref={scrollContainerRef}
        className={`flexbox justify-content--between align-items--center full-width tabs-section mb-16 ${className}`}
      >
        {!isAtStart && (
          <div className="arrow-wrapper left-overlay"/>
        )}
        <Tab
          size="small"
          color="light"
          tabItems={getTabItems({ t })}
          selectedValue={selectedTab}
          onSelect={(value) => onTabChange(value as string)}
        />
        {!isAtEnd && (
          <div className="arrow-wrapper right-overlay"/>
        )}
      </div>
    </div>
  );
};
